<template>
    <div class="page">
        <div class="header-block">
            <div class="title">{{$t('message.editGuest.title')}}</div>
            <Button type="primary" @click="showAddGuest">
                <Icon type="md-add" size="18" color="white" />
                <span class="add-text">{{$t('message.editGuest.addButton')}}</span>
            </Button>
        </div>

        <div class="line line-wrapper"></div>

        <div class="guest-list">

            <div v-for="guest in guestList" :key="guest.id" class="guest-block">
                <Icon type="md-person" size="20" color="#b2b2b2"/>
                <div class="name">{{getFullName(guest)}}</div>
                <div class="edit-icon">
                    <Icon @click="showEditGuest(guest)"  type="md-create" size="20" color="#b2b2b2"/>
                    <Icon @click="showDeleteGuest(guest)" class="del-icon" type="md-close" size="20" color="red" />
                </div>

            </div>

        </div>

<!--        编辑常住人对话框 start-->
        <Modal v-model="isShowEditGuest" :title="$t('message.editGuest.editGuest')" footer-hide
               :mask-closable="false" @on-visible-change="closeEditGuest">
            <Form ref="editGuest" :model="editGuest" :rules="ruleEditGuest">
                <FormItem :label="$t('message.editGuest.firstName')" prop="firstName">
                    <i-input type="text" v-model="editGuest.firstName" :placeholder="$t('message.editGuest.firstNamePlaceholder')"></i-input>
                </FormItem>
                <FormItem :label="$t('message.editGuest.lastName')" prop="lastName">
                    <i-input type="text" v-model="editGuest.lastName" :placeholder="$t('message.editGuest.lastNamePlaceholder')"></i-input>
                </FormItem>
                <FormItem>
                    <Button class="save-button" type="primary" @click="saveGuest">{{$t('message.editGuest.okButton')}}</Button>
                    <Button class="reset-button" type="default" @click="resetGuest">{{$t('message.editGuest.resetButton')}}</Button>
                </FormItem>
            </Form>
        </Modal>
<!--        编辑常住人对话框 end-->

<!--        删除常住人对话框 start-->
        <Modal v-model="isShowDeleteGuest" :title="$t('message.editGuest.deleteGuest')"
               :mask-closable="false" @on-ok="deleteGuest">
            <div class="delete-dialog">
                <Icon type="md-help-circle" size="40" color="orange"/>
                <p class="del-text">{{$t('message.editGuest.deleteText')}}</p>
            </div>
        </Modal>
<!--        删除常住人对话框 end-->

    </div>
</template>

<script>
  import {isEnglishNameValidate, urlRequest} from "../../common/common";

  export default {
    name: "GuestList",

    data() {

      const guestNameValidate = (rule, value, callback) => {
        if (!isEnglishNameValidate(value)) {
          callback(new Error('请用英文填写名字'));
        } else {
          callback();
        }
      };

      return {
        // 选中的常住人id
        selectedGuestId: 0,
        // 是否展示编辑常住人对话框
        isShowEditGuest: false,
        // 是否展示删除常住人对话框
        isShowDeleteGuest: false,
        // 常住人数据
        guestList: [],
        // 常住人数据
        editGuest: {
          // 常住人名
          firstName: '',
          // 常住人姓
          lastName: '',
        },
        // 常住人校验
        ruleEditGuest: {
          firstName: [
            {required: true, message: '常住人名字不能为空', trigger: 'blur'},
            {validator: guestNameValidate, trigger: 'blur'},
          ],
          lastName: [
            {required: true, message: '常住人名字不能为空', trigger: 'blur'},
            {validator: guestNameValidate, trigger: 'blur'},
          ],
        },
      }
    },

    created() {
      // 加载数据
      this.loadData();
    },

    methods: {

      // 展示新增常住人对话框
      showAddGuest() {
        console.log('show add guest');
        this.isShowEditGuest = true;
        this.selectedGuestId = 0;
      },

      // 展示编辑常住人对话框
      showEditGuest(guest) {
        this.isShowEditGuest = true;
        this.editGuest.firstName = guest.name;
        this.editGuest.lastName = guest.surname;
        this.selectedGuestId = guest.id;
      },

      // 展示删除常住人对话框
      showDeleteGuest(guest) {
        this.isShowDeleteGuest = true;
        this.selectedGuestId = guest.id;
      },

      // 删除常住人
      deleteGuest() {
        urlRequest({
          url: this.api.deleteGuest,
          method: 'POST',
          data: {
            'id': this.selectedGuestId
          }
        }).then(res => {
          this.$Message.success(res.data.msg);
          this.selectedGuestId = 0;
          this.loadData();
        });
      },

      // 保存常住人
      saveGuest() {
        this.$refs.editGuest.validate(valid => {
          if (valid) {
            // 校验成功后，调用保存常住人接口
            if (this.selectedGuestId > 0) {
              // 修改常住人
              urlRequest({
                url: this.api.editGuest,
                method: 'POST',
                data: {
                  'id': this.selectedGuestId,
                  'surname': this.editGuest.lastName,
                  'name': this.editGuest.firstName,
                }
              }).then(res => {
                this.$Message.success(res.data.msg);
                this.isShowEditGuest = false;
                this.resetGuest();
                // 将选中常住人id重置为0
                this.selectedGuestId = 0;
                this.loadData();
              });
            } else {
              // 新增常住人
              urlRequest({
                url: this.api.addGuest,
                method: 'POST',
                data: {
                  'surname': this.editGuest.lastName,
                  'name': this.editGuest.firstName,
                }
              }).then(res => {
                this.$Message.success(res.data.msg);
                this.isShowEditGuest = false;
                this.resetGuest();
                // 将选中常住人id重置为0
                this.selectedGuestId = 0;
                this.loadData();
              });
            }

          }
        });
      },

      // 重置常住人表单数据
      resetGuest() {
        this.$refs.editGuest.resetFields();
      },

      // 关闭常住人对话框时操作
      closeEditGuest(val) {
        if (!val) {
          // 重置对话框表单数据，防止影响下次显示
          this.resetGuest();
          // 将选中常住人id重置为0
          this.selectedGuestId = 0;
        }

      },

      // 加载数据
      loadData() {
        // 请求常住人数据
        urlRequest({
          url: this.api.getGuestList,
          method: 'POST'
        }).then(res => {
          this.guestList = res.data.msg.sort((a, b) => {
            return b.id - a.id;
          });
        });
      },

      // 获取全名
      getFullName(guest) {
        return `${guest.name} ${guest.surname}`;
      },

    }
  }
</script>

<style lang="scss" scoped>
    @import "../../assets/style/mainStyle.scss";
    @import "GuestList.scss";

</style>
